import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';

const PlaceholderDialog = ({
  openPlaceholderDialog,
  setOpenPlaceholderDialog,
}) => {
  const { t } = useTranslation();

  const placeHolderData = [
    { id: 1, placeholder: '{{user_name}}', data: t('task.email.placeholderDialog.userName') },
    { id: 2, placeholder: '{{user_email}}', data: t('task.email.placeholderDialog.userEmail') },
    { id: 3, placeholder: '{{user_id}}', data: t('task.email.placeholderDialog.userId') },
    { id: 4, placeholder: '{{user_dni}}', data: t('task.email.placeholderDialog.userDni') },
    { id: 5, placeholder: '{{user_role}}', data: t('task.email.placeholderDialog.userRole') },
    { id: 6, placeholder: '{{survey_title}}', data: t('task.email.placeholderDialog.surveyTitle') },
    { id: 7, placeholder: '{{survey_description}}', data: t('task.email.placeholderDialog.surveyDescription') },
    { id: 8, placeholder: '{{survey_type}}', data: t('task.email.placeholderDialog.surveyType') },
    { id: 9, placeholder: '{{survey_revision_policy}}', data: t('task.email.placeholderDialog.surveyRevisionPolicy') },
    { id: 10, placeholder: '{{task_instance_expected_responses}}', data: t('task.email.placeholderDialog.taskInstanceExpectedResponses') },
    { id: 11, placeholder: '{{task_instance_reset_scale}}', data: t('task.email.placeholderDialog.taskInstanceResetScale') },
    { id: 12, placeholder: '{{task_instance_category_code}}', data: t('task.email.placeholderDialog.taskInstanceCategoryCode') },
    { id: 13, placeholder: '{{location_name}}', data: t('task.email.placeholderDialog.locationName') },
    { id: 14, placeholder: '{{location_chain}}', data: t('task.email.placeholderDialog.locationChain') },
    { id: 15, placeholder: '{{location_internal_code}}', data: t('task.email.placeholderDialog.locationInternalCode') },
    { id: 16, placeholder: '{{survey_response_initial_latitude}}', data: t('task.email.placeholderDialog.surveyResponseInitialLatitude') },
    { id: 17, placeholder: '{{survey_response_initial_longitude}}', data: t('task.email.placeholderDialog.surveyResponseInitialLongitude') },
    { id: 18, placeholder: '{{survey_response_final_latitude}}', data: t('task.email.placeholderDialog.surveyResponseFinalLatitude') },
    { id: 19, placeholder: '{{survey_response_final_longitude}}', data: t('task.email.placeholderDialog.surveyResponseFinalLongitude') },
    { id: 20, placeholder: '{{survey_response_started_at}}', data: t('task.email.placeholderDialog.surveyResponseStartedAt') },
    { id: 21, placeholder: '{{survey_response_finished_at}}', data: t('task.email.placeholderDialog.surveyResponseFinishedAt') },
    { id: 22, placeholder: '{{survey_response_product_id}}', data: t('task.email.placeholderDialog.surveyResponseProductId') },
  ];
  const handleClose = () => {
    setOpenPlaceholderDialog(false);
  };

  return (
    <Dialog open={openPlaceholderDialog} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>{t('task.email.placeholderDialog.title')}</DialogTitle>
      <DialogContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('task.email.placeholderDialog.placeholder')}</TableCell>
              <TableCell>{t('task.email.placeholderDialog.data')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {placeHolderData.map((row) => (
              <TableRow key={row.id}>
                <TableCell>
                  {row.placeholder}
                </TableCell>
                <TableCell>
                  {row.data}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t('task.email.placeholderDialog.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PlaceholderDialog;
